export const dashboardRoute = ['dashboard'];
export const rolesRoute = ['roles', 'roleDetails'];
export const userRoute = ['users', 'userDetails', 'userActivity'];
export const websiteRoute = [
  'websiteAdmin',
  'websiteDetail',
  'websitesSuper',
  'websiteDetails',
];
export const categoryRoute = ['categories', 'CategoryDetails', 'categoryLabel'];
export const noisewordRoute = ['noiseWords', 'noiseWordDetails'];
export const serverRoute = ['server', 'serverDetails', 'logDetails'];
export const organizationRoute = [
  'organization',
  'organizationSettings',
  'logDetails',
];
export const dmcaFilesRoute = ['dmcaFiles', 'dmcaFilesView'];
export const crawlJobRoute = ['crawljobs', 'crawlView'];
export const manualSearchRoute = ['manualSearch'];
export const reportsRoute = ['reports'];
export const hitCountJobRoute=['hitCountJobs','hitCountView']